import classnames from 'classnames/bind'
import styles from './index.scss'

export const cx = classnames.bind(styles)
export const MAIN_CONTENT_ID = 'MAIN_CONTENT_ID'
